module.exports = __webpack_public_path__ + "static/media/unsubscribed-email.bb2fabf0.svg";